import { trackFocusMethod } from './utils.js';
import MainController from './main-controller.js';

trackFocusMethod();
new MainController(); // eslint-disable-line no-new
